export default __webpack_public_path__ + "static/media/statistics.4e8e4d29.svg";